import Vue from 'vue'
import Router from 'vue-router'
import Game from '@/components/game'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'game',
      component: Game,
    },
    {
      path: '*',
      name: 'game',
      component: Game,
    },
  ],
})
